import awsdk from 'awsdk';

// CREATED
// AWAITING_CONTACT_PERMISSION
// CONTACTING_PROVIDER
// PROVIDER_ACCEPTED
// TICKET_ACQUIRED
// COOL_DOWN
// PROVIDER_LIST_EXHAUSTED

export const FirstAvailableStatus = awsdk.AWSDKFirstAvailableStatus;
export type FirstAvailableStatus = typeof FirstAvailableStatus;
